import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {DetalhaSolicitacoesService} from 'src/app/services/detalha-solicitacoes.service';
import {first} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {AutenticacaoService} from 'src/app/services/autenticacao.service';
import {SharedService} from "../../services/shared.service";
import { BeneficiarioService } from 'src/app/services/beneficiario.service';
import { BusinessService } from 'src/app/services/business.service';
import { AutorizacaoService} from 'src/app/services/autorizacao.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-solicitacoes',
  templateUrl: './solicitacoes.component.html',
  styleUrls: ['./solicitacoes.component.scss'],
  providers: [MessageService]
})
export class SolicitacoesComponent implements OnInit {

  loading: boolean;
  cdUsuario: any;
  listaSolicitacoes: any [] = [];
  listaAutorizacoes: any [] = [];
  listaBeneficiarios: any [] = [];
  listaStatusAutorizacao: any [] = [];
  cdPessoa: any;
  p: number = 1;
  pageAut: number = 1;
  isVisibleSolicitacoes: boolean = false;
  isVisibleAutorizacoes: boolean = false;
  visualizaBotaoSolicitacoes: boolean = false;
  visualizaListaSolicitacoes: boolean = false;
  visualizaListaAutorizacoes: boolean = false;
  exibeAvisoRedeAtendimento: boolean = false;
  mensagemRedeAtendimento: SafeHtml = '';


  exibeMensagemFeriadoOuDesabilitado: boolean = false;
  isFeriadoOuDesabilitado: boolean = false;
  mensagemFeriadoOuDesabilitado: String = '';

  exibeAvisoAuto: boolean = false;
  mensagemAuto: SafeHtml = '';

  filtrosAutorizacao:any = {
    cdStatus: "",
    cdUsuario: "",
  };

  configListaAutorizacoes90dias: any = null;
  isVisibleListaAutorizacoes90dias: boolean = false;

  get window(): Window { return this.document.defaultView; }

  constructor(private router: Router, private messageService: MessageService,
              private autorizacaoService: AutorizacaoService,
              private detalhaSolicitacoesService: DetalhaSolicitacoesService,
              private autenticacaoService: AutenticacaoService, private sharedService: SharedService,
              private activatedRoute: ActivatedRoute,
              private beneficiarioService: BeneficiarioService,
              private businessService: BusinessService,
              private sanitizer: DomSanitizer,
              @Inject(DOCUMENT) readonly document: Document) {
  }

  ngOnInit() {
    this.loading = true;
    this.isVisibleSolicitacoes = false;
    this.cdUsuario = this.sharedService.beneficiario.cdUsuario;
    this.filtrosAutorizacao.cdUsuario = this.cdUsuario;
    this.filtrosAutorizacao.cdStatus = 0;
    this.cdPessoa = this.sharedService.beneficiario.cdPessoa;
    this.getFeriadoOuDesabilitado();
    this.getListaSolicitacoes();
    this.getListaAutorizacoes(this.filtrosAutorizacao);
    this.buscaBeneficiarios();
    this.buscaStatusAutorizacao();
    this.buscaConfigListaAutorizacoes90dias();
    this.loading = false;

    this.visualizaListaSolicitacoes = this.sharedService.visualizaListaSolicitacoes;
    this.visualizaBotaoSolicitacoes = this.sharedService.visualizaBotaoSolicitacoes;
    this.visualizaListaSolicitacoes = false;
    this.visualizaBotaoSolicitacoes = false;
    this.visualizaListaAutorizacoes = true;

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  async getListaSolicitacoes() {
    try {
      const res = await this.detalhaSolicitacoesService.buscaListaSolicitacoes(this.cdUsuario).toPromise();
      this.updateListaSolicitacoes(res);
      this.loading = false;
    } catch (error) {
      this.loading = false;
      if (error === "Unknown Error") {
        this.messageService.add({
          severity: 'error',
          summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
          life: 9999999
        });
      } else {
        this.messageService.add({severity: 'error', summary: 'Erro ao listar solicitações', life: 6000});
      }
    }
  }

  getListaAutorizacoes(filtros:any) {
    this.loading = true;
    this.detalhaSolicitacoesService.buscaListaAutorizacoes(filtros.cdUsuario, filtros.cdStatus).pipe(first())
    .subscribe(autorizacoes => {
        this.loading = false;
        return this.updateListaAutorizacoes(autorizacoes);
      },
      error => {
        this.loading = false;
        if (error === 'Unknown Error' || error === 'ERR_CONNECTION_REFUSED') {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Ops... Erro no servidor. Tente novamente em alguns instantes!',
              life: 9999999
            }
          );
        } else {
          this.messageService.add({severity: 'warn', summary: 'Erro ao listar beneficiários!', life: 6000});
        }
      }
    );
  }

  buscaConfigListaAutorizacoes90dias() {
    this.loading = true;
    this.detalhaSolicitacoesService.buscaConfigListaAutorizacoes90dias().pipe(first())
    .subscribe(config => {
        this.loading = false;
        return this.updateConfigListaAutorizacoes90dias(config);
      },
      error => {
        this.loading = false;
        if (error === 'Unknown Error' || error === 'ERR_CONNECTION_REFUSED') {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Ops... Erro no servidor. Tente novamente em alguns instantes!',
              life: 9999999
            }
          );
        } else {
          this.messageService.add({severity: 'warn', summary: 'Erro ao buscar config lista Autorizacoes 90dias!', life: 6000});
        }
      }
    );
  }

  updateConfigListaAutorizacoes90dias(config) {
    this.configListaAutorizacoes90dias = config;
    if (this.configListaAutorizacoes90dias.vlChave == 'S') {
      this.isVisibleListaAutorizacoes90dias = true;
    }
  }

  pesquisarAutorizacoes() {
    this.getListaAutorizacoes(this.filtrosAutorizacao);
  }

  buscaStatusAutorizacao() {
    this.listaStatusAutorizacao = ['LIBERADO', 'PENDENTE', 'INDEFERIDO'];
  }

  buscaBeneficiarios() {
    this.loading = true;
    this.beneficiarioService.buscaBeneficiarios(this.cdPessoa).pipe(first()).subscribe(beneficiarios => {
        this.loading = false;
        return this.updateListaBeneficiarios(beneficiarios);
      },
      error => {
        this.loading = false;
        if (error === 'Unknown Error' || error === 'ERR_CONNECTION_REFUSED') {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Ops... Erro no servidor. Tente novamente em alguns instantes!',
              life: 9999999
            }
          );
        } else {
          this.messageService.add({severity: 'warn', summary: 'Erro ao listar beneficiários!', life: 6000});
        }
      }
    );
  }

  updateListaBeneficiarios(beneficiarios) {
    this.listaBeneficiarios = beneficiarios;
  }

  updateListaAutorizacoes(autorizacoes) {
    this.listaAutorizacoes = autorizacoes;
    if (this.listaSolicitacoes.length > 0) {
      this.isVisibleAutorizacoes = true;
    }
  }

  updateListaSolicitacoes(res) {
    this.listaSolicitacoes = res;
    if (this.listaSolicitacoes.length === 0) {
      this.isVisibleSolicitacoes = true;
    }
  }

  redirecinaSolicitacao(solicitacao) {
    this.sharedService.beneficiarioSelecionado.nuControle = solicitacao.nuControle;
    localStorage.removeItem('currentUser');
    localStorage.setItem('currentUser', JSON.stringify(this.sharedService.beneficiarioSelecionado));
    this.router.navigate(['/solicitacoes/solicitacao']);
  }

  redirecinaNovaSolicitacao() {
    if (this.isFeriadoOuDesabilitado) {
      this.showMensagemFeriadoOuDesabilitado();
      return;
    } else {
      this.router.navigate(['/solicitacoes/nova-solicitacao']);
    }
  }

  validaRedeAtendimento(): boolean {
    this.beneficiarioService.validaRedeAtendimento(this.sharedService.beneficiarioSelecionado).pipe(first()).subscribe(mensagem => {
      if(mensagem) {
        this.exibeAvisoRedeAtendimento = false;
        this.mensagemRedeAtendimento = this.sanitizer.bypassSecurityTrustHtml(mensagem.mensagem);
      }
    }, err => console.log(err));
    return true;
  }

  navegaNovaSolicitacao() {
    this.exibeAvisoRedeAtendimento = false;
    if (this.isFeriadoOuDesabilitado) {
      this.showMensagemFeriadoOuDesabilitado();
      return;
    } else {
      this.router.navigate(['/solicitacoes/nova-solicitacao']);
    }

  }

  fecharMensagemFeriadoOuDesabilitado() {
    this.exibeMensagemFeriadoOuDesabilitado = false;
  }

  logout() {
    var businessId = this.autenticacaoService.logout();
    this.router.navigate(['/login'],{queryParams:{cod_empresa:businessId}});
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  async getFeriadoOuDesabilitado(){
    const cdEmpresa = this.getBusinessId();
    try {
      const res = await this.autorizacaoService.buscaFeriadoOuDesabilitado(cdEmpresa).toPromise();
      console.log(res);
      this.updateMensagemFeriadoOuDesabilitado(res);
      this.loading = false;
    } catch (error) {
      console.log(error)
      this.loading = false;
      if (error === "Unknown Error") {
        this.messageService.add({
          severity: 'error',
          summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
          life: 9999999
        });
      } else {
        this.messageService.add({severity: 'error', summary: 'Erro ao consultar feriado ou novas solicitações desabilitadas', life: 6000});
      }
    }
  }

  getBusinessId() {
    return this.businessService.getBusinessId();
  }

  showMensagemFeriadoOuDesabilitado() {
    if (this.isFeriadoOuDesabilitado) {
      this.exibeMensagemFeriadoOuDesabilitado = true;
    }
  }

  updateMensagemFeriadoOuDesabilitado(res) {
    this.mensagemFeriadoOuDesabilitado = (res.mensagem !== undefined) ? res.mensagem : null;
    this.isFeriadoOuDesabilitado = (this.mensagemFeriadoOuDesabilitado != null && this.mensagemFeriadoOuDesabilitado.trim().length > 0) ;
  }

  exibirAvisoFeriadoOuDesabilitado() {
    return this.isFeriadoOuDesabilitado;
  }

  exibirSolicitacoes() {
    this.visualizaListaSolicitacoes = true;
    this.visualizaBotaoSolicitacoes = false;
    this.visualizaListaAutorizacoes = false;
  }

  exibirAutorizacoes() {
    this.visualizaListaSolicitacoes = false;
    this.visualizaListaAutorizacoes = true;
  }

  imprimirGuia(cdSenha: string, cdPrestador: string): boolean {
    this.beneficiarioService.imprimirGuia(cdSenha, cdPrestador).pipe(first()).subscribe(mensagem => {
      if(mensagem) {
        this.redirect(mensagem.mensagem);
      } 
    }, err => console.log(err));
    return true;
  }

  public redirect(url: string, target = '_blank'): Promise<boolean> {
    console.log(url)
    return new Promise<boolean>( (resolve, reject) => {
      
     try { resolve(!!this.window.open(url, target)); }
     catch(e) { reject(e); }
  });
}
}
